module.exports = __webpack_public_path__ + "img/product2_007FFF_term.382d740c.png";